<script lang="ts">
	import { closeOverlay } from "overlay"
	import { Toast } from "toaster"
	import { DeviceUpdateManager } from "../../../../modules/device-operation-managers/DeviceUpdateManager"
	import { Responsive } from "responsive"

	interface Props {
		version: string
		isBeta: boolean
	}

	let { version, isBeta }: Props = $props()

	let isMobile = $derived(Responsive.isMobile)

	async function update() {
		closeOverlay()

		try {
			await DeviceUpdateManager.triggerUpdate()
			Toast.success(`Successfully updated!`)
		} catch (e) {
			console.error("Unable to update device.", e)
		}
	}
</script>

<div id="device-update-informer" class:isMobile>
	<div class="flex-row update-heading">
		<h1>Device Update Available</h1>
		<span>v{version}{isBeta ? "-beta" : ""}</span>
	</div>
	<p>
		A new firmware update is now available.
		<br />
		{Responsive.isMobile ? "Tap" : "Click"} the button below to begin. This may take up to 10 minutes
		depending on your network strength.
	</p>
	<span class="warn">
		While updating:
		<ul>
			<li>Do not disconnect the projector from power.</li>
			<li>Make sure your projector remains connected to a stable Wi-Fi network.</li>
		</ul>
	</span>
	<div class="button-container">
		<button class="outline-button" onclick={update}>Update now</button>
		<button class="outline-button alt" onclick={() => closeOverlay()}>Skip for now</button>
	</div>
</div>

<style>
	#device-update-informer {
		/* color: var(--color-text); */
		max-width: 40vw;
		padding-bottom: 1.5rem;
	}

	#device-update-informer.isMobile {
		max-width: unset;
		padding-bottom: 3rem;
	}

	h1 {
		margin: 1rem 0 0 0;
		font-size: var(--h0);
	}

	.isMobile h1 {
		font-size: var(--h1);
	}

	.update-heading span {
		margin-left: 1rem;
		margin-bottom: 0.2rem;
		color: var(--color-main);
	}

	.update-heading {
		align-items: flex-end;
		margin-bottom: 1rem;
	}

	p :global(svg) {
		height: 1rem;
		width: auto;
	}

	.isMobile p {
		line-height: 1.3;
	}

	.warn {
		color: var(--color-main);
	}

	ul {
		margin-left: 1.25rem;
		list-style: disc;
	}

	.button-container {
		width: fit-content;
		position: absolute;
		bottom: 0;
	}

	.button-container button {
		margin-right: 1rem;
	}

	.isMobile button {
		padding: 0 1rem;
		margin: 0;
	}

	.isMobile .button-container {
		width: calc(100% - 2rem);
		align-items: center;
		gap: 0;
	}
</style>
